import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { AuthService } from '@app/services/auth/auth.service';
//import { User } from 'oidc-client';
import { Subscription } from 'rxjs';
import { NavcontrolService } from '@app/services/navcontrol.service';

import { LoaderService } from '@app/services/loader/loader.service';
import { MemberService } from '@app/services/member.service';
import { ClaimsService } from '@app/services/claims/claims.service';
import { NavbarService } from '@app/services/shared/navbar.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

import { MemberformService } from '@app/services/states/memberform/memberform.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { InfoComponent } from '../../info/info.component';
import { NavigationEnd, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';


interface ActualUser {
  memberid: number;
  givenName: string;
  familyName: string;
}

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnDestroy {
  @ViewChild('navbarToggler', { static: true }) navbarToggler: ElementRef;
  @ViewChild('role') roleelement;
  selectedindex = 0;
  subscriptions: Subscription[] = [];
  username: string;
  actualuser: ActualUser = { memberid: 0, givenName: null, familyName: null };
  //user: User;
  showLoader = false;
  loaderSubscription: Subscription;

  memberaccess;

  navcontrol;
  ownid: number;
  medid: number;

  userpermissions;

  result = '';
  roleid = 4;
  roles: any[] = [];
  access;
  userpermissionlevel;
  userdomain;
isAuthenticated = false;
  role;
  mobiledevice = false;
  roleinstitution;
  roleinstitutionlabel;
  activerole;
  permissions;
  isImpersonated = false;
  isCollapsed = true;
userid;
claims;
  constructor(
    private authService: AuthService,
    private bottomSheet: MatBottomSheet,
   
    private permissionsService: PermissionsService,
    private router: Router,
    private navcontrolService: NavcontrolService,
    private navbarService: NavbarService,
    private claimsService: ClaimsService,
    private loaderService: LoaderService,
    private memberService: MemberService,
    private memberformService: MemberformService,
    private confirmationService: ConfirmationService) {

    this.subscriptions.push(this.authService.username.subscribe(u => this.username = u));
    this.subscriptions.push(this.navcontrolService.navcontrol.subscribe(n => this.navcontrol = n));
    this.permissionsService.setMemberAccess();
    this.subscriptions.push(this.authService.isMobileDevice.subscribe(mobile => {
      this.mobiledevice = mobile;
    }));

    this.subscriptions.push(this.memberformService.medid.subscribe(data => {
      this.medid = Number(data);
    }));

    this.subscriptions.push(this.permissionsService.access.subscribe(y => {
      this.memberaccess = y;
    }));

    this.subscriptions.push(this.permissionsService.selectedrole.subscribe(x => {
      if (x) {
        this.role = x;
        this.permissions = x.permissions;
        this.roleid = x.roleId;
        this.selectedindex = Number(this.permissionsService.selectedindex.getValue());
        this.roleinstitution = x.institution.id;
        this.roleinstitutionlabel = x.institution.shortName + ' - ' + x.institution.name;
        this.mobiledevice = window.navigator.userAgent.toLowerCase().includes('mobi');
        this.access = x.permissions;
        this.userpermissionlevel = x.userPermissionLevel;
        this.userdomain = x.userDomain;
      }
    }));
   
    // Rensa medid om vi inte är i medlemsformuläret och tittar på en medlemsbild.
    this.subscriptions.push(this.router.events.subscribe(data => {
      if (data instanceof NavigationEnd) {
        if (data.url.indexOf('memberform/id') === -1 && data.url.indexOf('changepassword/id') === -1) {
          this.memberformService.medid.next(null);
        }
      }
    }));

   /* this.subscriptions.push(this.authService.enhancedUserData$.subscribe(item => {
      if (item) {
        this.actualuser = {
          memberid: Number(item.data.name),
          givenName: item.data.email,
          familyName: 'familyname'
        };
      }
    }));*/
   /* this.subscriptions.push(this.claimsService.claims$.subscribe(item => {
      if (item) {
        this.actualuser = {
          memberid: Number(item.id),
          givenName: item.givenName,
          familyName: item.familyName
        };
      }
    }));*/
  }

  setHelpActive() {
    this.navbarService.helpopened$.next(!this.navbarService.helpopened$.getValue());
  }

  checkRights(role: string) {
    if (localStorage.getItem('permissions')) {
      return localStorage.getItem('permissions').indexOf(role) !== -1;
    }
  }

  validate(text) {
    return this.access.findIndex(text);
  }

  setRole(evt) {
    console.log('setRole');
    this.selectedindex = Number(this.roleelement.nativeElement.selectedIndex);
    const idx = this.selectedindex;
    this.roleid = this.roles[this.selectedindex].id;
    this.permissionsService.selectedindex.next(idx);
    this.selectedindex = idx;
   
    localStorage.setItem('selectedindex', JSON.stringify(idx));
    this.subscriptions.push(this.permissionsService.changeActiveRole(this.roleid, idx).subscribe(x => {
      this.permissionsService.setMemberAccess();
      this.permissionsService.setSelectedRole(this.selectedindex);
      sessionStorage.setItem(
      "selectedrole",
      JSON.stringify(this.permissionsService.selectedrole.getValue())
    );

     this.permissionsService.setSelectedRole(
                  Number(localStorage.getItem("selectedindex"))
                );

      this.router.navigateByUrl('/start/newrole');
    }));
  }

  ngOnInit() {
   
this.claimsService.claims$.subscribe(x => {
  if(x){
   
  this.username = x.givenName + ' ' + x.familyName;
  }
});

    this.authService.claims.subscribe(claims => {
      if(claims) {
      
        this.isImpersonated = claims.some(
          claim => claim.type === 'impersonated' && claim.value === 'true'
        ) ?? false;

       this.permissionsService.userid = claims.find(c => c.type === 'name')?.value;
           // this.userid = this.permissionsService.userid;
           this.userid = JSON.parse(sessionStorage.getItem('userid'));
         
             this.actualuser = {
                memberid: Number(claims.find(c => c.type === 'name')?.value),
                givenName: claims.find(c => c.type === 'email')?.value,
                familyName: ''
        };
      }
    })
     /*this.authService.enhancedUserData$.subscribe(data => {
      if(this.oidcSecurityService.userData$) {
            console.log('Alla claims:', data);
            this.claims = data.claims;
             this.permissionsService.userid = this.claims.find(c => c.type === 'name')?.value;
            this.userid = this.permissionsService.userid;
             this.actualuser = {
                memberid: Number(this.userid),
                givenName: this.claims.find(c => c.type === 'email')?.value,
                familyName: 'xxx'
        };
      }
     });*/
    const navbarItems = document.querySelectorAll('.navbar-nav>dropdown-item>li');
    navbarItems.forEach(navbarItem => {
      navbarItem.addEventListener('click', () => {
        const navbar = document.querySelector('.navbar-collapse');
        navbar.classList.remove('show');
      })
    });
    const logoutItems = document.querySelectorAll('.logout');
    logoutItems.forEach(navbarItem => {
      navbarItem.addEventListener('click', () => {
        const navbar = document.querySelector('.navbar-collapse');
        navbar.classList.remove('show');
      })
    });

    // Hämta roller kopplade till aktuell användare
    this.subscriptions.push(this.permissionsService.userpermissions.subscribe(x => {
      if (x) {
       
        x.userRoles.forEach(r => {
          if (r.institution) {
            if (r.commiteeName != null) {
              this.roles.push({ id: r.roleId, label: r.roleDescription + ' i ' + r.commiteeName + ' [' + r.institution?.shortName + '   ' + r.institution?.name + ']' });

            } else {
              this.roles.push({ id: r.roleId, label: r.roleDescription + ' [' + r.institution?.shortName + '   ' + r.institution?.name + ']' });
            }
          } else {
            this.roles.push({ id: r.roleId, label: r.roleDescription });
          }
        });
        let idx = 0;
        this.roles.map(r => { r.idx = idx++; });
        this.permissionsService.changeActiveRole(x.userRoles[0].roleId, 0).subscribe(x => {
        //  console.log('x: ', x);
        });
      }
    }));
    this.navcontrolService.updateNavControl();
    this.subscriptions.push(this.loaderSubscription = this.loaderService.loaderState.subscribe(x => {
      this.showLoader = x.show;
    }));

    
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }

  logout() {
    this.confirmDialog();
  }

  /*confirmDialog(): void {
    const message = 'Logga ut ur medlemsregistret ?';
    const dialogData = new ConfirmDialogModel('', message, 'logout', true);
    const dialogRef = this.dialog.open(ConfirmdialogComponent, {
      hasBackdrop: true,
      restoreFocus: true,
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      this.result = dialogResult;
      if (this.result) {
        sessionStorage.removeItem('selectedrole');
        this.permissionsService.roleidx = 4;
        this.authService.logout();
         
        
   
        this.router.navigate(['']);
      }
    });
  }*/
 confirmDialog() {
        this.confirmationService.confirm({
            header: 'Logga ut från SVOMS',
            message: 'Logga ut ur medlemsregistret ?',
            accept: () => {
                 sessionStorage.removeItem('selectedrole');
        this.permissionsService.roleidx = 4;
        this.authService.logout();
        this.router.navigate(['']);
            },
            reject: () => {
                //this.confirmationService.add({ severity: 'info', summary: 'Avslag', detail: 'Det skapas ingen Excelfil med alla SOFT-prenumeranter.' });
            },
        });
    }
    

  navBarTogglerIsVisible() {
    return this.navbarToggler.nativeElement.offsetParent !== null;
  }

  collapseNav() {
    if (this.navBarTogglerIsVisible()) {
      this.navbarToggler.nativeElement.click();
    }
  }

  soft() {
    this.memberService.timestamp.next(+new Date());
  }

 /* confirmSOFTReport() {
    const message = 'Vill du skapa en Excelfil med alla SOFT-prenumeranter ?';
    const dialogData = new ConfirmDialogModel('', message, 'confirm', true);
    const dialogRef = this.dialog.open(ConfirmdialogComponent, {
      minWidth: '400px',
      minHeight: '200px',
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      this.result = dialogResult;
      if (this.result) {
        this.soft();
      }
    });
  }*/

   confirmSOFTReport() {
        this.confirmationService.confirm({
            header: 'SOFT-lista',
            message: 'Vill du skapa en Excelfil med alla SOFT-prenumeranter ?',
            accept: () => {
                this.soft();
            },
            reject: () => {
                //this.confirmationService.add({ severity: 'info', summary: 'Avslag', detail: 'Det skapas ingen Excelfil med alla SOFT-prenumeranter.' });
            },
        });
    }

  viewInfo() {
    this.bottomSheet.open(InfoComponent);
  }

  
}
